{
  "bankLogin": {
    "enteringCredentials": "Entering credentials...",
    "submittingLogin": "Submitting login...",
    "twoFaRequired": "2FA required for bank login",
    "twoFaRequiredSms": "2FA required for bank login — SMS mTAN sent to phone",
    "twoFaTimedOut": "Bank login failed — 2FA timeout",
    "twoFaRejected": "Bank login failed — 2FA code rejected by the bank",
    "appNotReached": "Bank login failed — app did not load after 2FA",
    "submittingMtanCode": "Submitting mTAN code...",
    "successful": "Bank login successful",
    "alreadyAuthenticated": "Already logged in — reusing existing bank session",
    "sessionExpiredRelogin": "Bank session expired — signing back in...",
    "credentialsNotConfigured": "Bank credentials not configured",
    "bankTypeNotConfigured": "Bank type not configured"
  },
  "login": {
    "failed": "Login failed"
  },
  "twoFa": {
    "codeTimedOut": "2FA code timed out waiting for user input",
    "codeReceived": "2FA code received",
    "requiredForConfirmation": "2FA required for payment confirmation",
    "codeReceivedSubmitting": "2FA code received, submitting payment...",
    "enterCode": "Enter 2FA code",
    "preparingAppium": "Starting Android emulator and mobile token app — this can take a minute...",
    "appiumReady": "Android emulator ready",
    "fetchingViaAppium": "Requesting one-time code from the ASA mobile app...",
    "openingMToken": "Opening mToken in the ASA mobile app...",
    "codeReceivedViaAppium": "One-time code read from the ASA mobile app",
    "appiumPinNotConfigured": "Mobile app PIN is not configured",
    "appiumFailed": "Could not fetch the code from the mobile app: {{error}}"
  },
  "payment": {
    "processingInvoice": "Processing invoice: {{addressName}} - {{providerName}} ({{amount}} {{currency}})",
    "failed": "Payment failed: {{error}}",
    "complete": "Payment processing complete. {{successCount}} succeeded, {{failCount}} failed.",
    "cancelledByUser": "Payment cancelled by user",
    "alreadyInProgress": "Payment already in progress",
    "doneSummary": "Processed {{count}} invoice(s)",
    "oneOrMoreFailed": "One or more payments failed",
    "processingFailed": "Payment processing failed"
  },
  "camofox": {
    "starting": "Starting browser...",
    "ready": "Browser ready"
  },
  "paymentForm": {
    "navigatingDomestic": "Navigating to domestic payment form...",
    "navigatingDomesticTransfer": "Navigating to domestic transfer form...",
    "fillingBeneficiaryDetails": "Filling beneficiary details...",
    "fillingBeneficiaryAccount": "Filling beneficiary account number...",
    "fillingBeneficiaryName": "Filling beneficiary name...",
    "fillingBeneficiaryAddress": "Filling beneficiary address...",
    "proceedingToDetails": "Proceeding to payment details...",
    "fillingPaymentDetails": "Filling payment details...",
    "fillingFormDetails": "Filling payment form details...",
    "enteringAmount": "Entering payment amount...",
    "enteringReference": "Entering payment reference...",
    "enteringReferenceNote": "Entering payment reference (note)...",
    "enteringBeneficiaryName": "Entering beneficiary name...",
    "proceedingToConfirmation": "Proceeding to confirmation...",
    "waitingForMtan": "Waiting for mTAN authorization prompt...",
    "enteringMtanCode": "Entering mTAN code for payment confirmation...",
    "submittingPaymentOrder": "Submitting payment order...",
    "successful": "Payment successful!",
    "orderNotConfirmed": "Payment failed — order was not confirmed",
    "paymentFailed": "Payment failed",
    "paymentBlocked": "Payment blocked pending verification",
    "amountMismatch": "Amount mismatch — expected {{expected}}, form shows {{rendered}}",
    "amountConfirmed": "Payment amount confirmed: {{amount}}",
    "allDetailsFilledConfirming": "All payment details filled, confirming payment...",
    "signToastValidated": "Bank confirmed signing (success notification)",
    "signToastMissing": "No bank confirmation yet — verifying in the order list",
    "tabOrderFound": "Order found under {{tab}} ({{rows}} rows)",
    "tabOrderMissing": "Order not under {{tab}} ({{rows}} rows)",
    "leavingStaleForm": "Discarding previously filled slip (order {{order}})...",
    "freshFormReady": "Fresh blank domestic payment form is ready",
    "orderReadyToSubmit": "Bank accepted the form — submitting order..."
  },
  "mock": {
    "simulationMode": "=== Mock ASA Bank — Simulation Mode ===",
    "loadedInvoices": "Loaded {{count}} hardcoded invoice(s) for simulation.",
    "connectingToBank": "Connecting to ASA Bank (e.banka.ba)...",
    "amountLabel": "Amount: {{amount}} {{currency}}",
    "referenceLabel": "Reference: {{reference}}",
    "beneficiaryLabel": "Beneficiary: {{beneficiary}}",
    "accountLabel": "Account: {{account}}"
  },
  "scraping": {
    "noPendingInvoices": "No pending invoices to pay.",
    "failed": "Scraping failed",
    "testMode": "Running in TEST PAYMENT mode.",
    "testModeDeprecated": "Test payment mode is deprecated — use the API to trigger payments.",
    "zeroDebtCompleted": "Debt is {{amount}}; {{date}} marked as COMPLETED due to zero debt.",
    "statusCompleted": "Debt is {{amount}}; {{date}} is already COMPLETED.",
    "statusFailed": "Debt is {{amount}}; {{date}} is in FAILED status. Please check manually.",
    "statusPaid": "Debt is {{amount}}; {{date}} is already PAID. Waiting for {{providerName}} to process it.",
    "statusSkipped": "Debt is {{amount}}; {{date}} is SKIPPED.",
    "statusProcessing": "Debt is {{amount}}; {{date}} is to be paid.",
    "statusUnknown": "Debt is {{amount}}; {{date}} is in {{status}} status.",
    "pendingInvoiceNotReady": "Debt is {{amount}}; {{date}}, invoice not yet prepared by provider.",
    "pendingInvoiceNotDelivered": "Invoice not delivered yet — {{reason}}.",
    "pendingInvoiceNotDeliveredWithDebt": "Debt is {{amount}}; {{date}}, invoice not delivered yet — {{reason}}.",
    "pendingZeroDebt": "Debt is {{amount}}; {{date}} has zero debt.",
    "pendingInvoiceDownloaded": "Debt is {{amount}}; {{date}} is new. Downloaded invoice.",
    "pendingInvoiceNoDownload": "Debt is {{amount}}; {{date}} is new. No file download available.",
    "skipPaymentDisabled": "Will skip payment as it is disabled.",
    "belowMinimumSkipped": "Debt is {{amount}}, which is below the minimum invoice amount; {{date}} marked as SKIPPED.",
    "error": "{{errorMessage}}"
  },
  "scheduler": {
    "noUsersConfigured": "No users with configured scraping schedules found.",
    "scheduledUser": "Scheduling scraper for user {{name}} at {{time}}",
    "initialized": "Scheduler initialized — {{count}} user(s) scheduled.",
    "removed": "Removed scraper for user {{userId}}.",
    "stopped": "Scheduler stopped.",
    "invalidTime": "Invalid scrapingTime \"{{time}}\" for user {{userId}}, skipping."
  },
  "connection": {
    "failed": "Connection failed"
  },
  "appium": {
    "startingInfra": "Starting Appium infrastructure (emulator + server)..."
  }
}
